"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedContractAdapter = exports.JRC20ContractAdapter = exports.EVMCallAdapter = exports.ERC20TokenHandler = exports.ContractManager = void 0;
const ethers_1 = require("ethers");
const asset_1 = require("../../asset");
const transaction_1 = require("../../transaction");
const abi = __importStar(require("./abi"));
class ContractManager {
    handlers = [];
    async getHandler(contractAddress) {
        for (const handler of this.handlers) {
            if (await handler.instanceOf(contractAddress)) {
                return handler;
            }
        }
        return null;
    }
    registerHandler(handler) {
        // register at first position because of getHandler iteration implementation
        // since specific handler may have common functions with default ones
        // it is preferable to check if it is part of those first.
        // Should do a better getHandler function in the future
        this.handlers.unshift(handler);
    }
    async balanceOf(provider, contractAddress, address) {
        const contract = new ethers_1.ethers.Contract(contractAddress, abi.BalanceOfABI, provider);
        return BigInt.asUintN(256, BigInt(await contract.balanceOf(address)));
    }
    getTransferData(provider, contractAddress, to, amount) {
        const contract = new ethers_1.ethers.Contract(contractAddress, abi.TransferABI, provider);
        return contract.interface.encodeFunctionData('transfer', [to, amount]);
    }
}
exports.ContractManager = ContractManager;
class ERC20TokenHandler {
    provider;
    constructor(provider) {
        this.provider = provider;
    }
    async instanceOf(contractAddress) {
        const contract = this.getContract(contractAddress);
        // checking if is ERC20 by calling decimals read only function
        // other main tokens interfaces should not be using decimals
        // IERC165 is not widespread enough to be used by ERC20 tokens
        await contract.decimals().catch(() => {
            return false;
        });
        return true;
    }
    async queryTokenData(contractAddress) {
        const contract = this.getContract(contractAddress);
        const name = await contract.name();
        const symbol = await contract.symbol();
        const decimals = await contract.decimals();
        return new asset_1.ERC20Asset(contractAddress, name, symbol, decimals);
    }
    getContract(contractAddress) {
        return new ethers_1.ethers.Contract(contractAddress, abi.ERC20ABI, this.provider);
    }
}
exports.ERC20TokenHandler = ERC20TokenHandler;
class EVMCallAdapter {
    contract;
    constructor(contractAddress, abi) {
        this.contract = new ethers_1.ethers.Contract(contractAddress, abi);
    }
    getFunctionData(name, parameters = []) {
        return this.contract.interface.encodeFunctionData(name, parameters);
    }
}
exports.EVMCallAdapter = EVMCallAdapter;
class JRC20ContractAdapter extends EVMCallAdapter {
    contractAddress;
    constructor(contractAddress) {
        super(contractAddress, abi.JRC20ABI);
        this.contractAddress = contractAddress;
    }
    getWithdrawData(value) {
        return this.getFunctionData('withdraw', [value]);
    }
    getDepositData(assetId, amount) {
        // native asset call data
        let data = ethers_1.ethers.solidityPacked(['address', 'uint256', 'uint256'], [this.contractAddress, `0x${new transaction_1.AssetId(assetId).serialize().toHex()}`, amount]);
        // add deposit function removed hex prefix
        data += this.getFunctionData('deposit').substring(2);
        return data;
    }
}
exports.JRC20ContractAdapter = JRC20ContractAdapter;
class WrappedContractAdapter extends EVMCallAdapter {
    constructor(contractAddress) {
        super(contractAddress, abi.WrappedABI);
    }
    getWithdrawData(value) {
        return this.getFunctionData('withdraw', [value]);
    }
    getDepositData() {
        return this.getFunctionData('deposit');
    }
}
exports.WrappedContractAdapter = WrappedContractAdapter;
